module.exports = __webpack_public_path__ + "static/media/icon_check_tag.5ce8e9ac.svg";